import type {
  AddCompanyCreditsPayload,
  CompanyCreditBalanceResponse,
  CompanyCreditTransaction,
  CompanyCreditTransactionsResponse,
} from '@/api/(admin)/credits/types';
import { BACKEND_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';

/** Admin endpoints live on `VITE_BACKEND_URI` — see the note in `(admin)/companies`. */

export async function fetchCompanyCreditBalance(
  companyId: string,
): Promise<CompanyCreditBalanceResponse> {
  return apiFetch<CompanyCreditBalanceResponse>(
    `/admin/companies/${companyId}/credits/balance`,
    {},
    BACKEND_URL,
  );
}

/** The ledger. Takes a pre-built query string; paging lives in the hook. */
export async function fetchCompanyCreditTransactions(
  companyId: string,
  qs: string,
): Promise<CompanyCreditTransactionsResponse> {
  return apiFetch<CompanyCreditTransactionsResponse>(
    `/admin/companies/${companyId}/credits?${qs}`,
    {},
    BACKEND_URL,
  );
}

export async function addCompanyCredits(
  companyId: string,
  payload: AddCompanyCreditsPayload,
): Promise<{ data: CompanyCreditTransaction }> {
  return apiFetch<{ data: CompanyCreditTransaction }>(
    `/admin/companies/${companyId}/credits`,
    { method: 'POST', body: JSON.stringify(payload) },
    BACKEND_URL,
  );
}
